import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
// Dashboard pages
const Overview = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Overview.vue')
const Widgets = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Widgets.vue')

// Pages
import User from 'src/components/Dashboard/Views/Pages/UserProfile.vue'
import TimeLine from 'src/components/Dashboard/Views/Pages/TimeLinePage.vue'
import Login from 'src/components/Dashboard/Views/Pages/Login.vue'
import Logout from 'src/components/Dashboard/Views/Pages/Logout.vue'
import Register from 'src/components/Dashboard/Views/Pages/Register.vue'
import Lock from 'src/components/Dashboard/Views/Pages/Lock.vue'
import Companies from 'src/components/Dashboard/Views/Pages/Companies.vue'
import CreateTask from 'src/components/Dashboard/Views/Pages/CreateTask.vue'
import CreateTaskDetails from 'src/components/Dashboard/Views/Pages/CreateTaskDetails.vue'
import ViewEntity from 'src/components/Dashboard/Views/Pages/ViewEntity.vue'
import CreateEntity from 'src/components/Dashboard/Views/Pages/CreateEntity.vue'
import CreateOfficer from 'src/components/Dashboard/Views/Pages/CreateOfficer.vue'
import ViewOfficer from 'src/components/Dashboard/Views/Pages/ViewOfficer.vue'
import EditTask from 'src/components/Dashboard/Views/Pages/EditTask.vue'
import CsDashboard from 'src/components/Dashboard/Views/Pages/CsDashboard.vue'
import CreateShareTransaction from 'src/components/Dashboard/Views/Pages/CreateShareTransaction.vue'
import ViewDocument from 'src/components/Dashboard/Views/Pages/ViewDocument.vue'
import EditShareholder from 'src/components/Dashboard/Views/Pages/EditShareholder.vue'
import CreateOfficerChange from 'src/components/Dashboard/Views/Pages/CreateOfficerChange.vue'
import ResolutionBuilder from 'src/components/Dashboard/Views/Pages/ResolutionBuilder.vue'
import DocumentSigning from 'src/components/Dashboard/Views/Pages/DocumentSigning.vue'
import ViewShareCert from 'src/components/Dashboard/Views/Pages/ViewShareCert.vue'
import CreatePerson from 'src/components/Dashboard/Views/Pages/CreatePerson.vue'
import People from 'src/components/Dashboard/Views/Pages/People.vue'
import EditCompanyInfoChange from 'src/components/Dashboard/Views/Pages/EditCompanyInfoChange.vue'
import EditShareCertChange from 'src/components/Dashboard/Views/Pages/EditShareCertChange.vue'
import EditProfile from 'src/components/Dashboard/Views/Pages/EditProfile.vue'
import TaskLog from 'src/components/Dashboard/Views/Pages/TaskLog.vue'
import EditShareholderCompany from 'src/components/Dashboard/Views/Pages/EditShareholderCompany.vue'
import EditRecurringBill from 'src/components/Dashboard/Views/Pages/EditRecurringBill.vue'
import EditInvoice from 'src/components/Dashboard/Views/Pages/EditInvoice.vue'
import AdminConsole from 'src/components/Dashboard/Views/Pages/AdminConsole.vue'
import EditAccount from 'src/components/Dashboard/Views/Pages/EditAccount.vue'
import ViewRequestDocument from 'src/components/Dashboard/Views/Pages/ViewRequestDocument.vue'
import ViewKeyDocument from 'src/components/Dashboard/Views/Pages/ViewKeyDocument.vue'
import NotificationLog from 'src/components/Dashboard/Views/Pages/NotificationLog.vue'
import Invoices from 'src/components/Dashboard/Views/Pages/Invoices.vue'
import RequestMessages from 'src/components/Dashboard/Views/Pages/RequestMessages.vue'
import DigitalMailbox from 'src/components/Dashboard/Views/Pages/DigitalMailbox.vue'
import ViewMail from 'src/components/Dashboard/Views/Pages/ViewMail.vue'
import Compliance from 'src/components/Dashboard/Views/Pages/Compliance.vue'
import ComplianceUpdates from 'src/components/Dashboard/Views/Pages/ComplianceUpdates.vue'
import ViewComplianceUpdate from 'src/components/Dashboard/Views/Pages/ViewComplianceUpdate.vue'
import ViewCommonDocument from 'src/components/Dashboard/Views/Pages/ViewCommonDocument.vue'
import ClientPortalInfo from 'src/components/Dashboard/Views/Pages/ClientPortalInfo.vue'
import CreateMemberChange from 'src/components/Dashboard/Views/Pages/CreateMemberChange.vue'
import EntityDocuments from 'src/components/Dashboard/Views/Pages/EntityDocuments.vue'
import ViewFolder from 'src/components/Dashboard/Views/Pages/ViewFolder.vue'
import UploadDocument from 'src/components/Dashboard/Views/Pages/UploadDocument.vue'
import ManageFolders from 'src/components/Dashboard/Views/Pages/ManageFolders.vue'
import EditShareholderDetails from 'src/components/Dashboard/Views/Pages/EditShareholderDetails.vue'
import EditShareholderCompanyDetails from 'src/components/Dashboard/Views/Pages/EditShareholderCompanyDetails.vue'
import CompanyRegister from 'src/components/Dashboard/Views/Pages/CompanyRegister.vue'
import EditFolder from 'src/components/Dashboard/Views/Pages/EditFolder.vue'
import ComplianceControllers from 'src/components/Dashboard/Views/Pages/ComplianceControllers.vue'
import EsigningOverview from 'src/components/Dashboard/Views/Pages/EsigningOverview.vue'
import ViewEntityAssociates from 'src/components/Dashboard/Views/Pages/ViewEntityAssociates.vue'
import ViewComplianceForm from 'src/components/Dashboard/Views/Pages/ViewComplianceForm.vue'
import ViewAssociates from 'src/components/Dashboard/Views/Pages/ViewAssociates.vue'
import AddCommission from 'src/components/Dashboard/Views/Pages/AddCommission.vue'
import ViewCommission from 'src/components/Dashboard/Views/Pages/ViewCommission.vue'
import ViewMyCommission from 'src/components/Dashboard/Views/Pages/ViewMyCommission.vue'
import ForgetPassword from 'src/components/Dashboard/Views/Pages/ForgetPassword.vue'
import ResetPassword from 'src/components/Dashboard/Views/Pages/ResetPassword.vue'



// Components pages
import Buttons from 'src/components/Dashboard/Views/Components/Buttons.vue'
import GridSystem from 'src/components/Dashboard/Views/Components/GridSystem.vue'
import Panels from 'src/components/Dashboard/Views/Components/Panels.vue'
import SweetAlert from 'src/components/Dashboard/Views/Components/SweetAlert.vue'
import Notifications from 'src/components/Dashboard/Views/Components/Notifications.vue'
import Icons from 'src/components/Dashboard/Views/Components/Icons.vue'
import Typography from 'src/components/Dashboard/Views/Components/Typography.vue'

// Forms pages
const RegularForms  = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/RegularForms.vue')
const ExtendedForms = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/ExtendedForms.vue');
const ValidationForms = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/ValidationForms.vue')
const Wizard = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/Wizard.vue');

// TableList pages
const RegularTables = () => import(/* webpackChunkName: "tables" */ 'src/components/Dashboard/Views/Tables/RegularTables.vue');
const ExtendedTables = () => import(/* webpackChunkName: "tables" */ 'src/components/Dashboard/Views/Tables/ExtendedTables.vue');
const PaginatedTables = () => import(/* webpackChunkName: "tables" */ 'src/components/Dashboard/Views/Tables/PaginatedTables.vue');
// Maps pages
const GoogleMaps = () => import(/* webpackChunkName: "maps" */ 'src/components/Dashboard/Views/Maps/GoogleMaps.vue')
const FullScreenMap = () => import(/* webpackChunkName: "maps" */ 'src/components/Dashboard/Views/Maps/FullScreenMap.vue')
const VectorMaps = () => import(/* webpackChunkName: "maps" */ 'src/components/Dashboard/Views/Maps/VectorMapsPage.vue');

// Calendar
import Calendar from 'src/components/Dashboard/Views/Calendar/CalendarRoute.vue'
// Charts
const Charts = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Charts.vue')

let componentsMenu = {
  path: '/components',
  component: DashboardLayout,
  redirect: '/components/buttons',
  children: [
    {
      path: 'buttons',
      name: 'Buttons',
      component: Buttons
    },
    {
      path: 'grid-system',
      name: 'Grid System',
      component: GridSystem
    },
    {
      path: 'panels',
      name: 'Panels',
      component: Panels
    },
    {
      path: 'sweet-alert',
      name: 'Sweet Alert',
      component: SweetAlert
    },
    {
      path: 'notifications',
      name: 'Notifications',
      component: Notifications
    },
    {
      path: 'icons',
      name: 'Icons',
      component: Icons
    },
    {
      path: 'typography',
      name: 'Typography',
      component: Typography
    }

  ]
}
let formsMenu = {
  path: '/forms',
  component: DashboardLayout,
  redirect: '/forms/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Forms',
      component: RegularForms
    },
    {
      path: 'extended',
      name: 'Extended Forms',
      component: ExtendedForms
    },
    {
      path: 'validation',
      name: 'Validation Forms',
      component: ValidationForms
    },
    {
      path: 'wizard',
      name: 'Wizard',
      component: Wizard
    }
  ]
}

let tablesMenu = {
  path: '/table-list',
  component: DashboardLayout,
  redirect: '/table-list/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Tables',
      component: RegularTables
    },
    {
      path: 'extended',
      name: 'Extended Tables',
      component: ExtendedTables
    },
    {
      path: 'paginated',
      name: 'Paginated Tables',
      component: PaginatedTables
    }]
}

let mapsMenu = {
  path: '/maps',
  component: DashboardLayout,
  redirect: '/maps/google',
  children: [
    {
      path: 'google',
      name: 'Google Maps',
      component: GoogleMaps
    },
    {
      path: 'full-screen',
      name: 'Full Screen Map',
      component: FullScreenMap
    },
    {
      path: 'vector-map',
      name: 'Vector Map',
      component: VectorMaps
    }
  ]
}

let pagesMenu = {
  path: '/pages',
  component: DashboardLayout,
  redirect: '/pages/user',
  children: [
    {
      path: 'user',
      name: 'User Page',
      component: User
    },
    {
      path: 'timeline',
      name: 'Timeline Page',
      component: TimeLine
    }
  ]
}

let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login,
  meta: {
        public: true,  // Allow access to even if not logged in
        onlyWhenLoggedOut: true
 }
}


let forgetPage = {
  path: '/forget-password',
  name: 'Forget Password',
  component: ForgetPassword,
  meta: {
        public: true,  // Allow access to even if not logged in
        onlyWhenLoggedOut: true
 }
}


let resetPage = {
  path: '/reset-password/:token',
  name: 'Reset Password',
  component: ResetPassword,
  meta: {
        public: true,  // Allow access to even if not logged in
        onlyWhenLoggedOut: true
 }
}




let registerPage = {
  path: '/register',
  name: 'Register',
  component: Register,
  meta: {
        public: true,  // Allow access to even if not logged in
        onlyWhenLoggedOut: true
  }
}

let lockPage = {
  path: '/lock',
  name: 'Lock',
  component: Lock
}

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/cs_dashboard',
    children: [
      {
        path: 'calendar',
        name: 'Calendar',
        component: Calendar
      },
      {
        path: 'logout',
        name: 'Logout',
        component: Logout
      },
      {
        path: 'companies',
        name: 'Companies',
        component: Companies
      },
      {
        path: 'charts',
        name: 'Charts',
        component: Charts
      },
      { path: '/create-entity/:id',
  		name: 'Create Entity',
  		component: CreateEntity
  	   },
  	   { path: '/create-officer/:oid/entity/:eid',
  		name: 'Create Officer',
  		component: CreateOfficer
  	   },
  	   { path: '/create-share-transaction/:stid/entity/:eid/:type',
  		name: 'Create Share Transaction',
  		component: CreateShareTransaction
  	   },
  	   { path: '/create-officer-change/:ocid/entity/:eid/:type',
  		name: 'Create Officer Change',
  		component: CreateOfficerChange
  	   },
  	   { path: '/create-member-change/:mcid/entity/:eid/:type',
  		name: 'Create Member Change',
  		component: CreateMemberChange
  	   },
      { path: '/create-task/:id',
  		name: 'Create Task',
  		component: CreateTask
  	   },
  	   { path: '/create-task-details/:eid/:taskname/:cid/:tid/:type',
  		name: 'Complete Task Details',
  		component: CreateTaskDetails
  	   },
  	    { path: '/view-entity/:id',
  		name: 'View Entity Details',
  		component: ViewEntity
  	   },
  	   { path: '/view-document/:did/:type',
  		name: 'View Document',
  		component: ViewDocument
  	   },
  	    { path: '/view-officer/:oid/entity/:eid',
  		name: 'View Officer Details',
  		component: ViewOfficer
  	   },
  	    { path: '/edit-task/:tid/entity/:eid',
  		name: 'Update Task',
  		component: EditTask
  	   },
  	    { path: '/edit-shareholder/:shid/entity/:eid/:type',
  		name: 'Edit Shareholder',
  		component: EditShareholder
  	   },
  	  { path: '/edit-shareholder-details/:shid/entity/:eid/:type',
  		name: 'Edit ShareholderDetails',
  		component: EditShareholderDetails
  	   },
  	   
  	    { path: '/edit-shareholder-company-details/:shid/entity/:eid/:type',
  		name: 'Edit ShareholderCompanyDetails',
  		component: EditShareholderCompanyDetails
  	   },
  	   
  	     { path: '/resolution-builder/:tid/entity/:eid/',
  		name: 'Resolution Build',
  		component: ResolutionBuilder
  	   },
  	   { path: '/document-signing/:tid/entity/:eid/:type/:did',
  		name: 'Document Signing',
  		component: DocumentSigning
  	   },
  	   { path: '/view-share-cert/:scid/entity/:eid',
  		name: 'Share Cerificate',
  		component: ViewShareCert
  	   },
  	    { path: '/cs_dashboard',
  		name: 'CS Dashboard',
  		component: CsDashboard
  	   },
  	     { path: '/create-person/:pid',
  		name: 'Add Person To Database',
  		component: CreatePerson
  	   },
  	    { path: '/people',
  		name: 'People',
  		component: People
  	   },
  	    { path: '/edit-change-company-info/:cicid/entity/:eid',
  		name: 'Edit Change: Company Info',
  		component: EditCompanyInfoChange
  	   },
  	   { path: '/edit-change-share-cert/:sccid/entity/:eid',
  		name: 'Edit Change: Share Certificate',
  		component: EditShareCertChange
  	   },
  	    { path: '/edit-profile',
  		name: 'Edit Profile',
  		component: EditProfile
  	   },
  	   { path: '/edit-account',
  		name: 'Edit Account',
  		component: EditAccount
  	   },
  	     { path: '/task-log',
  		name: 'Task Log',
  		component: TaskLog
  	   },
  	    { path: '/invoices',
  		name: 'Billing',
  		component: Invoices
  	   },
  	     { path: '/notification-log',
  		name: 'Notfication Log',
  		component: NotificationLog
  	   },
  	     { path: '/request-messages',
  		name: 'Request Messages',
  		component: RequestMessages
  	   },
  	     { path: '/edit-shareholder-company/:shcid',
  		name: 'Edit Shareholder Company',
  		component: EditShareholderCompany
  	   },
  	   { path: '/edit-recurring-bill/:rbid/entity/:eid',
  		name: 'Edit Recurring Bill',
  		component: EditRecurringBill
  	   },
  	    { path: '/edit-invoice/:iid/entity/:eid/task/:tid',
  		name: 'Edit Invoice',
  		component: EditInvoice
  	   },
  	   { path: '/sadmin/console',
  		name: 'Admin Console',
  		component: AdminConsole
  	   },
  	    { path: '/view-request-document/:did',
  		name: 'View Request Document',
  		component: ViewRequestDocument
  	   },
  	     { path: '/view-key-document/:did',
  		name: 'View Key Document',
  		component: ViewKeyDocument
  	   },
  	     { path: '/digital-mailbox/:eid',
  		name: 'Digital Mailbox',
  		component: DigitalMailbox
  	   },
  	  { path: '/view-mail/:mid',
  		name: 'View Mail',
  		component: ViewMail
  	   },
  	    { path: '/compliance',
  		name: 'Compliance',
  		component: Compliance
  	   },
  	   { path: '/compliance-updates/:shid/entity/:eid',
  		name: 'Compliance Updates',
  		component: ComplianceUpdates
  	   },
  	   { path: '/view-compliance-update/:cuid',
  		name: 'View Compliance Update',
  		component: ViewComplianceUpdate
  	   },
  	    { path: '/view-common-document/:cdid',
  		name: 'View Document',
  		component: ViewCommonDocument
  	   },
  	    { path: '/client-portal/:eid',
  		name: 'Client Portal Details',
  		component: ClientPortalInfo
  	   },
  	    { path: '/entity-documents/:eid',
  		name: 'Documents',
  		component: EntityDocuments
  	   },
  	   { path: '/view-folder/:dfid/entity/:eid',
  		name: 'View Folder',
  		component: ViewFolder
  	   },
  	     { path: '/esigning-overview',
  		name: 'E-signing Overview',
  		component: EsigningOverview
  	   },
  	    { path: '/upload-document/entity/:eid',
  		name: 'Compliance Updates',
  		component: UploadDocument
  	   },
  	    { path: '/manage-folders/entity/:eid',
  		name: 'Compliance Updates',
  		component: ManageFolders
  	   }, 
  	   { path: '/edit-folder/:fid/entity/:eid',
  		name: 'Compliance Updates',
  		component: EditFolder
  	   },
  	    { path: '/compliance-controllers',
  		name: 'Compliance - Register Of Registrable Controllers',
  		component: ComplianceControllers
  	   },
  	    { path: '/company-register/:eid',
  		name: 'Company Register',
  		component: CompanyRegister
  	   },
  	    { path: '/entity-associates/:eid',
  		name: 'Entity\'s Associates',
  		component: ViewEntityAssociates
  	   },
  	   { path: '/view-compliance-form/:cfid/:shid',
  		name: 'View Compliance Form',
  		component: ViewComplianceForm
  	   },
  	   { path: '/associates',
  		name: 'View Associates',
  		component: ViewAssociates
  	   },
  	    { path: '/add-commission/:aid',
  		name: 'Add Commission',
  		component: AddCommission
  	   },
		{ path: '/view-commission/:aid',
  		name: 'View Commission',
  		component: ViewCommission
  	   },
  	   { path: '/my-commission',
  		name: 'View My Commission',
  		component: ViewMyCommission
  	   },
  	   
  	   
    ] 
  },
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  loginPage,
  forgetPage,
  resetPage,
  registerPage,
  lockPage,
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/overview',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      },
      {
        path: 'widgets',
        name: 'Widgets',
        component: Widgets
      }
    ]
  },
  {path: '*', component: NotFound}
];

export default routes
